/**
 * @Description: 自定义指令：复制（czw tip，会暴露明文，废弃）
 */

/* eslint-disable */
import Clipboard from 'clipboard'
import { message } from 'ant-design-vue'
import { saveCopyLog } from "@/api/detail";

const hasClipboard = {
    install(Vue, options) {
        Vue.directive('clipboard', {
            bind(el, binding, vnode) {
                const clip = new Clipboard(el)
                const params = binding.value
                el.dataset.clipboardText = typeof params === 'object' ? params.copyFieldValue : params
                clip.on('success', (e) => {
                    message.success('复制成功，请前往粘贴！')
                    // if (typeof params === 'object') {
                    //     saveCopyLog(params).then(res => {
                    //         console.log('复制记录报备成功～')
                    //     })
                    // }
                })
                clip.on('error', (e) => {
                    console.error('Action:', e.action)
                    console.error('Trigger:', e.trigger)
                })
            },
            update(el, binding) {
                const params = binding.value
                el.dataset.clipboardText = params.copyFieldValue
            },
        })
    },
}

export default hasClipboard
/* eslint-disable */
